import { Spacing } from "components/designV2/constants";
import { Color, ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";
import styled from "styled-components";

const INDIVIDUAL_SALARY_GRID_TEMPLATE = "120px repeat(6, minmax(0, 1fr)) 120px";

export const EmptyStateWrapper = styled.div`
  text-align: center;
  margin-top: 40px;
`;

export const SalaryNoticeRowCard = styled.div<{ $isLastItem: boolean }>`
  background-color: ${ColorV2.White};
  padding: ${Spacing.md}px ${Spacing.lg}px;
  border-radius: 24px;
  display: grid;
  grid-template-columns: ${INDIVIDUAL_SALARY_GRID_TEMPLATE};
  align-items: center;
  column-gap: ${Spacing.md}px;
  margin-bottom: ${(props) => (props.$isLastItem ? 0 : 10)}px;
`;

export const RowActions = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacing.sm}px;
`;

export const SalaryPeriodCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

export const SalaryPeriodValueRow = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${Spacing.sm}px;
`;

export const SalaryPeriodValue = styled.span`
  ${TypographyV2.b2};
  color: ${ColorV2.Blue1};
`;

export const SalaryPeriodLabel = styled.span`
  ${TypographyV2.s1};
  color: ${ColorV2.Blue4};
`;

export const InlinePayLogo = styled.img`
  width: 40px;
  height: 12px;
  object-fit: contain;
`;

export const SummaryGrid = styled.div`
  display: grid;
  grid-template-columns: ${INDIVIDUAL_SALARY_GRID_TEMPLATE};
  align-items: center;
  column-gap: ${Spacing.md}px;
  padding: ${Spacing.md}px ${Spacing.lg}px;
  background-color: ${Color.Positive};
  border-radius: 24px;
  margin-top: ${Spacing.md}px;
`;
